// ng-zorro default width for circle type
export const defaultProgressWidth = 132;
